<script setup>
import { computed } from "vue";

const props = defineProps({
  importResult: {
    type: Object,
    required: true,
  },
});

const hasTotal = computed(
  () => props.importResult?.total !== undefined && props.importResult?.total !== null
);

const errorCount = computed(
  () => props.importResult?.errors ?? props.importResult?.error ?? 0
);

function formatCellValue(value) {
  if (value === null || value === undefined || value === "") {
    return "-";
  }
  return String(value);
}

function formatErrorValue(value) {
  if (value === null || value === undefined || value === "") {
    return "Importado correctamente";
  }
  return String(value);
}

function getValidIconClass(value) {
  if (value === null || value === undefined || value === "") {
    return "";
  }
  return value ? "fa fa-check" : "fa fa-times";
}
</script>

<template>
  <section aria-label="Resultado de importacion">
    <div v-if="hasTotal" class="row g-2">
      <div class="col">
        <div class="import-result__metric">
          <span class="text-xxs text-secondary font-weight-bolder text-uppercase">Total</span>
          <span class="d-block mt-1 text-dark">{{ props.importResult?.total ?? 0 }}</span>
        </div>
      </div>
      <div class="col">
        <div class="import-result__metric">
          <span class="text-xxs text-secondary font-weight-bolder text-uppercase">Correctos</span>
          <span class="d-block mt-1 text-success">{{ props.importResult?.created ?? 0 }}</span>
        </div>
      </div>
      <div class="col">
        <div class="import-result__metric">
          <span class="text-xxs text-secondary font-weight-bolder text-uppercase">Con error</span>
          <span class="d-block mt-1 text-danger">{{ errorCount }}</span>
        </div>
      </div>
    </div>

    <div
      v-if="hasTotal && errorCount === 0 && (props.importResult?.total ?? 0) > 0"
      class="import-result__success mt-3"
    >
      <i class="fa fa-check-circle me-1"></i>
      Importación completada sin errores
    </div>

    <div v-if="!hasTotal" class="import-result__success mt-3">
      <i class="fa fa-check-circle me-1"></i>
      {{ props.importResult?.created ?? 0 }} registros creados correctamente
    </div>

    <details
      v-if="Array.isArray(props.importResult?.items) && props.importResult.items.length"
      class="import-result__details"
      open
    >
      <summary class="import-result__summary">
        Detalle Importación ({{ props.importResult.items.length }})
      </summary>
      <div class="import-result__tbody-wrapper mt-2">
        <table class="table table-sm mb-0 import-result__table">
          <tbody>
            <tr
              v-for="(item, index) in props.importResult.items"
              :key="`import-error-${index}`"
            >
              <td class="import-result__col-num text-secondary">#{{ index + 1 }}</td>
              <td class="import-result__col-ext">{{ formatCellValue(item.external_id) }}</td>
              <td class="import-result__col-err">{{ formatErrorValue(item.error) }}</td>
              <td class="import-result__col-valid text-center">
                <i
                  v-if="getValidIconClass(item.valid)"
                  :class="[getValidIconClass(item.valid), item.valid ? 'text-success' : 'text-danger']"
                ></i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </details>
  </section>
</template>

<style scoped>
.import-result__metric {
  border: 1px solid var(--premium-modal-border, rgba(15, 23, 42, 0.08));
  border-radius: 8px;
  padding: 8px 6px;
  min-height: 62px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.import-result__success {
  font-size: 0.82rem;
  font-weight: 600;
  color: #2dce89;
}

.import-result__details {
  margin-top: 12px;
}

.import-result__summary {
  cursor: pointer;
  font-size: 0.82rem;
  font-weight: 700;
  color: #4f5e72;
}

.import-result__tbody-wrapper {
  max-height: 180px;
  overflow-y: auto;
  overflow-x: hidden;
}

.import-result__table {
  table-layout: fixed;
  width: 100%;
}

.import-result__col-num  { width: 10%; }
.import-result__col-ext  { width: 25%; }
.import-result__col-err  { width: 45%; white-space: normal; overflow-wrap: anywhere; }
.import-result__col-valid { width: 20%; }
</style>
